export default "__VITE_ASSET__CIHgE8Ku__"